import { render } from "./BdeAudit.vue?vue&type=template&id=c1d1a570&lang=pug"
import script from "./BdeAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./BdeAudit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__